import {
  ERROR_RESPONSE,
  RESET_ERROR,
  RESET_REDUX,
  SET_SAMPLES_DONE_FLAG,
  SET_SAMPLES_SAVED_FLAG,
  RESET_SUCCESS,
  SET_REVIEW_HEATMAP_TYPE,
  REQUEST_SYNC_STUDIES,
  RECEIVE_SYNC_STUDIES,
  SUCCESS_RESPONSE,
  TOGGLE_REVIEW_HEATMAP,
  TOGGLE_NOTES_FOCUS,
  TOGGLE_REVIEW_FILTER_DRAWER,
  WARNING_RESPONSE,
  RESET_WARNING,
  RESET_RESULT_SNACKBAR,
  OPEN_RESULT_SNACKBAR,
  SET_FOCUS_ELEMENT,
  RECEIVE_PROTOCOL,
  SET_AUTO_ADVANCE_DIALOG_STATE,
  SET_AUTO_ADVANCE_SNACKBAR_STATE,
  TOGGLE_ACQUIRE_BAR,
  TOGGLE_AUTO_ADVANCE,
  SET_CAMERA_MODAL,
  REQUEST_EXPORT_STUDY_PDF,
  RECEIVE_EXPORT_STUDY_PDF,
  CANCEL_PHOTO,
  SET_VIRTUAL_KEYBOARD,
  TOGGLE_VIRTUAL_KEYBOARD_ALLOWED,
  REQUEST_FACE_DETECTION,
  RESET_FACE_DETECTION,
  TOGGLE_QUIT_STUDY_DIALOG,
  RECEIVE_FACE_DETECTION,
  SET_SAVE_AND_QUIT,
  RECEIVE_EXPORT_STUDY_CSV,
  REQUEST_EXPORT_STUDY_CSV,
  SET_THEME,
  SET_AVAILABLE_DRIVES,
  REQUEST_EXPORT_STUDIES,
  RECEIVE_EXPORT_STUDIES,
  TOGGLE_SKIP_DIAGNOSTICS_SETUP,
  TOGGLE_SHOW_COMPLETED,
  SET_HEATMAP_TYPE,
  TOGGLE_HEATMAP,
  SET_HEATMAP_LIMIT,
  // WIFI
  REQUEST_CHECK_WIFI,
  RECEIVE_CHECK_WIFI,
  RESET_CHECK_WIFI,
  RESET_WIFI_CONNECTION,
  RECEIVE_WIFI_CONNECTION,
  REQUEST_WIFI_CONNECTION,

  // DIALOG TOGGLE
  TOGGLE_WIFI_DIALOG,
  TOGGLE_DIAGNOSTICS_DIALOG,
  TOGGLE_LOAD_DIALOG,
  TOGGLE_LOCK_DIALOG,
  TOGGLE_SAVE_DIALOG,
  TOGGLE_PROTOCOL_DIALOG,
  TOGGLE_EXPORT_PDF_DIALOG,
  TOGGLE_SYNC_STUDIES_DIALOG,
  TOGGLE_EXPORT_STUDIES_DIALOG,
  TOGGLE_EXISTING_PARTICIPANTS_DIALOG,
  TOGGLE_EXPORT_CSV_DIALOG,

  // MODES
  TOGGLE_REMOVE_LOCATION_MODE,
  TOGGLE_EDIT_MAP_MODE,
  SET_CREATE_PROTOCOL_MODE,
  TOGGLE_ADD_NEW_LOCATION_MODE,
} from "../actions/index";

import produce from "immer";

import { heatmapEmodeType } from "../constants/constants";

const initialState = {
  // DIALOG
  dialog: {
    studyLoadDialog: false,
    studySaveDialog: false,
    saveProtocolDialog: false,
    studyLockDialog: false,
    exportPdfDialog: false,
    exportCsvDialog: false,
    exportStudiesDialog: false,
    existingParticipantsDialog: false,
    syncStudiesDialog: false,
    diagnosticsDialog: false,
    quitDialog: false,
    wifiDialog: false,
  },

  // WIFI
  wifi: {
    fetchingCheckWifi: false,
    availableNetworks: [],
    fetchingWifiConnection: false,
    wifiConnection: false,
  },

  // MODE
  mode: {
    createProtocolMode: false,
    addNewLocationMode: false,
    removeLocationMode: false,
    editMapMode: false,
  },

  resultSnackbar: { status: false, value: null, sampleType: null },
  error: {
    status: false,
  },
  success: {
    status: false,
  },
  warning: {
    status: false,
  },
  heatmap: {
    status: false,
    type: heatmapEmodeType,
    swsLimit: [1, 8],
    thicknessLimit: [0, 4],
  },
  showCompleted: true,
  notesFocus: false, //disable keypress actions if the user is typing on the notes section of results
  focusElement: null,
  autoAdvance: false,
  showAutoAdvancePopup: false,
  showAutoAdvanceSnackbar: false,
  showAcquireBar: true,
  cameraModal: { status: false, id: null },
  requestExportPdf: false,
  requestExportCsv: false,
  requestExportStudies: false,
  requestSyncStudies: false,
  samplesDone: true,
  samplesSaved: true,
  virtualKeyboardAllowed: false,
  virtualKeyboard: false,
  saveAndQuit: false,
  fetchingFaceDetection: false,
  theme: "dark",
  usbDrives: {},
  skipDiagnosticsSetup: false,
  filterDrawer: false,
  reviewHeatmap: {
    status: true,
    type: heatmapEmodeType,
    swsLimit: [1, 8],
    thicknessLimit: [0, 4],
  },
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // DIALOG TOGGLES
      case TOGGLE_PROTOCOL_DIALOG: {
        draft.dialog.saveProtocolDialog = !draft.dialog.saveProtocolDialog;
        break;
      }
      case TOGGLE_SAVE_DIALOG: {
        draft.dialog.studySaveDialog = !draft.dialog.studySaveDialog;
        break;
      }
      case TOGGLE_LOAD_DIALOG: {
        draft.dialog.studyLoadDialog = !draft.dialog.studyLoadDialog;
        break;
      }
      case TOGGLE_LOCK_DIALOG: {
        draft.dialog.studyLockDialog = !draft.dialog.studyLockDialog;
        break;
      }
      case TOGGLE_EXPORT_STUDIES_DIALOG: {
        draft.dialog.exportStudiesDialog = !draft.dialog.exportStudiesDialog;
        break;
      }
      case TOGGLE_EXISTING_PARTICIPANTS_DIALOG: {
        draft.dialog.existingParticipantsDialog =
          !draft.dialog.existingParticipantsDialog;
        break;
      }
      case TOGGLE_SYNC_STUDIES_DIALOG: {
        draft.dialog.syncStudiesDialog = !draft.dialog.syncStudiesDialog;
        break;
      }
      case TOGGLE_DIAGNOSTICS_DIALOG: {
        draft.dialog.diagnosticsDialog = !draft.dialog.diagnosticsDialog;
        break;
      }
      case TOGGLE_EXPORT_PDF_DIALOG: {
        draft.dialog.exportPdfDialog = !draft.dialog.exportPdfDialog;
        break;
      }
      case TOGGLE_EXPORT_CSV_DIALOG: {
        draft.dialog.exportCsvDialog = !draft.dialog.exportCsvDialog;
        break;
      }
      case TOGGLE_WIFI_DIALOG: {
        draft.dialog.wifiDialog = !draft.dialog.wifiDialog;
        break;
      }
      case TOGGLE_QUIT_STUDY_DIALOG: {
        draft.dialog.quitDialog = !draft.dialog.quitDialog;
        break;
      }

      // WIFI CONNECTION
      case REQUEST_CHECK_WIFI: {
        draft.wifi.availableNetworks = [];
        draft.wifi.wifiConnection = false;
        draft.wifi.fetchingCheckWifi = true;

        break;
      }

      case RECEIVE_CHECK_WIFI: {
        draft.wifi.availableNetworks = action.availableNetworks;
        draft.wifi.wifiConnection = action.wifiConnection;
        draft.wifi.fetchingCheckWifi = false;

        break;
      }

      case RESET_CHECK_WIFI: {
        draft.wifi.availableNetworks = [];
        draft.wifi.wifiConnection = false;
        draft.wifi.fetchingCheckWifi = false;

        break;
      }
      case REQUEST_WIFI_CONNECTION: {
        draft.wifi.wifiConnection = false;
        draft.wifi.fetchingWifiConnection = true;
        break;
      }
      case RECEIVE_WIFI_CONNECTION: {
        draft.wifi.wifiConnection = action.wifiConnection;
        draft.wifi.fetchingWifiConnection = false;
        break;
      }
      case RESET_WIFI_CONNECTION: {
        draft.wifi.wifiConnection = false;
        draft.wifi.fetchingWifiConnection = false;
        break;
      }

      // MODES
      case SET_CREATE_PROTOCOL_MODE: {
        draft.mode.createProtocolMode = action.status;
        break;
      }
      case TOGGLE_REMOVE_LOCATION_MODE: {
        draft.mode.removeLocationMode = !draft.mode.removeLocationMode;
        break;
      }
      case TOGGLE_EDIT_MAP_MODE: {
        draft.mode.editMapMode = !draft.mode.editMapMode;
        break;
      }

      case TOGGLE_ADD_NEW_LOCATION_MODE: {
        draft.mode.addNewLocationMode = !draft.mode.addNewLocationMode;
        break;
      }

      // OTHER
      case TOGGLE_HEATMAP: {
        draft.heatmap.status = !draft.heatmap.status;
        break;
      }
      case SET_HEATMAP_TYPE: {
        draft.heatmap.type = action.heatmapType;
        break;
      }

      case SET_HEATMAP_LIMIT: {
        draft.heatmap.swsLimit = action.swsLimit;
        draft.heatmap.thicknessLimit = action.thicknessLimit;
        break;
      }

      case TOGGLE_SHOW_COMPLETED: {
        draft.showCompleted = !draft.showCompleted;
        break;
      }

      case RECEIVE_PROTOCOL: {
        if (Object.keys(action.setProtocol.locations).length !== 0) {
          draft.focusElement = Object.keys(action.setProtocol.locations)[0]; // Default
        }
        break;
      }
      case SET_FOCUS_ELEMENT: {
        draft.focusElement = action.id;
        break;
      }

      case ERROR_RESPONSE: {
        draft.error = { status: true, message: "Error: " + action.error };
        break;
      }

      case RESET_ERROR: {
        draft.error = { status: false, message: null };
        break;
      }

      case SET_SAVE_AND_QUIT: {
        draft.saveAndQuit = action.status;
        break;
      }
      case CANCEL_PHOTO: {
        draft.samplesDone = true;
        break;
      }

      case SET_SAMPLES_DONE_FLAG: {
        draft.samplesDone = action.status;
        break;
      }

      case SET_SAMPLES_SAVED_FLAG: {
        draft.samplesSaved = action.status;
        break;
      }

      case TOGGLE_NOTES_FOCUS: {
        draft.notesFocus = !draft.notesFocus;
        break;
      }

      case RESET_SUCCESS: {
        draft.success = { status: false, message: null };
        break;
      }

      case SUCCESS_RESPONSE: {
        draft.success = { status: true, message: "Success: " + action.message };
        break;
      }

      case RESET_WARNING: {
        draft.warning = { status: false, message: null };
        break;
      }

      case WARNING_RESPONSE: {
        draft.warning = { status: true, message: "Warning: " + action.message };
        break;
      }

      case OPEN_RESULT_SNACKBAR: {
        draft.resultSnackbar.status = true;
        draft.resultSnackbar.value = action.value;
        draft.resultSnackbar.sampleType = action.sampleType;
        break;
      }

      case RESET_RESULT_SNACKBAR: {
        draft.resultSnackbar.status = false;
        break;
      }

      case TOGGLE_AUTO_ADVANCE: {
        draft.autoAdvance = !draft.autoAdvance;
        break;
      }
      case SET_AUTO_ADVANCE_DIALOG_STATE: {
        draft.showAutoAdvancePopup = action.state;
        break;
      }
      case SET_AUTO_ADVANCE_SNACKBAR_STATE: {
        draft.showAutoAdvanceSnackbar = action.state;
        break;
      }

      case TOGGLE_ACQUIRE_BAR: {
        draft.showAcquireBar = !draft.showAcquireBar;
        break;
      }

      case TOGGLE_SKIP_DIAGNOSTICS_SETUP: {
        draft.skipDiagnosticsSetup = !draft.skipDiagnosticsSetup;
        break;
      }

      case TOGGLE_REVIEW_FILTER_DRAWER: {
        draft.filterDrawer = !draft.filterDrawer;
        break;
      }

      case SET_CAMERA_MODAL: {
        draft.cameraModal = { status: action.status, id: action.id };
        break;
      }

      case REQUEST_EXPORT_STUDY_PDF: {
        draft.requestExportPdf = true;
        break;
      }
      case TOGGLE_REVIEW_HEATMAP: {
        draft.reviewHeatmap.status = !draft.reviewHeatmap.status;
        break;
      }
      case SET_REVIEW_HEATMAP_TYPE: {
        draft.reviewHeatmap.type = action.reviewHeatmapType;
        break;
      }
      case RECEIVE_EXPORT_STUDY_PDF: {
        draft.requestExportPdf = false;
        break;
      }
      case REQUEST_EXPORT_STUDY_CSV: {
        draft.requestExportCsv = true;
        break;
      }
      case RECEIVE_EXPORT_STUDY_CSV: {
        draft.requestExportCsv = false;
        break;
      }

      case REQUEST_EXPORT_STUDIES: {
        draft.requestExportStudies = true;
        break;
      }

      case RECEIVE_EXPORT_STUDIES: {
        draft.requestExportStudies = false;
        break;
      }

      case REQUEST_SYNC_STUDIES: {
        draft.requestSyncStudies = true;
        break;
      }

      case RECEIVE_SYNC_STUDIES: {
        draft.requestSyncStudies = false;
        break;
      }
      case SET_VIRTUAL_KEYBOARD: {
        if (draft.virtualKeyboardAllowed) {
          draft.virtualKeyboard = action.state;
        }
        break;
      }
      case REQUEST_FACE_DETECTION: {
        draft.fetchingFaceDetection = true;
        break;
      }

      case RECEIVE_FACE_DETECTION: {
        draft.fetchingFaceDetection = false;
        break;
      }

      case RESET_FACE_DETECTION: {
        draft.fetchingFaceDetection = false;
        break;
      }

      case TOGGLE_VIRTUAL_KEYBOARD_ALLOWED: {
        draft.virtualKeyboardAllowed = !draft.virtualKeyboardAllowed;
        draft.virtualKeyboard = false;
        break;
      }

      case SET_THEME: {
        draft.theme = draft.theme === "light" ? "dark" : "light";
        break;
      }

      case SET_AVAILABLE_DRIVES: {
        draft.usbDrives = action.usbDrives;
        break;
      }

      case RESET_REDUX:
        return { ...initialState, theme: draft.theme };

      default:
        return draft;
    }
  });
